<template>
  <div class="main scroll">
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name">首页</div>
          <div class="icon">></div>
          <div class="name">观察档案</div>
        </div>
        <div class="right">
          <div class="time"></div>
        </div>
      </div>

      <div class="content-box">
        <div class="left">
          <div class="class">
            <div class="name">{{ className }}</div>

          </div>
          <div class="tip">
            本学期记录数
          </div>
          <div class="students">
            <div
              v-for="(item, index) in students"
              @click="changeStudent(index)"
              :key="index"
              :class="{ active: currentStudent == index }"
              class="student-item"
            >
              <div class="name">{{ item.name }}</div>
              <div v-show="index != 0" class="msg">
                <span>H</span>{{ item.h }} <span>L</span> {{ item.l }} <span>S</span> {{ item.s }}
                <span>SM</span> {{ item.sm }} <span>A</span> {{ item.a }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="head">
            <div class="title">{{ className }}观察记录</div>
            <div class="tabs">
              <a-tabs v-model="tabIndex" @change="changeTab">
                <a-tab-pane key="0" tab="园所观察"></a-tab-pane>
                <a-tab-pane key="1" tab="家庭记录"></a-tab-pane>
                <a-tab-pane key="2" tab="观察任务"></a-tab-pane>
              </a-tabs>
              <div class="pos">
                <!-- <div @click="handleStudentLevelReport" style="margin-right:20px" class="cg">
                  学生评估报告
                </div> -->
                <div @click="showDraft = true" class="cg">
                  草稿箱
                </div>
                <a-dropdown>
                  <div class="push">
                    +新建记录
                  </div>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <router-link to="/observe/add">发布观察记录</router-link>
                    </a-menu-item>
                    <a-menu-item>
                      <router-link to="/observe/addTask"
                        >发布观察任务</router-link
                      >
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
          </div>
          <div class="list-wrap">
            <div class="search">
              <div class="flex-row">
                <a-range-picker
                  v-if="tabIndex==0"
                  style="width: 240px;"
                  v-model="searchDate"
                  @change="changeDateTime"
                  show-time
                  size="small"
                >
                  <a-icon slot="suffixIcon" type="carry-out" />
                </a-range-picker>
                <a-range-picker
                  v-if="tabIndex==1"
                  style="width: 240px;"
                  @change="changeDateJt"
                  show-time
                  size="small"
                >
                  <a-icon slot="suffixIcon" type="carry-out" />
                </a-range-picker>

                <a-select
                  v-if="tabIndex==0"
                  style="width:120px;margin-left:10px"
                  v-model="observeListForm.type"
                  size="small"
                >
                  <a-select-option key="" value="">全部类型</a-select-option>
                  <a-select-option key="1" value="notable"
                    >快速记</a-select-option
                  >
                  <a-select-option key="2" value="record"
                    >观察记录表</a-select-option
                  >
                </a-select>

                <a-select
                  v-if="tabIndex == 0"
                  style="width:120px;margin-left:10px;"
                  v-model="observeListForm.teacher_id"
                  size="small"
                >
                  <a-select-option key="" value="">全部记录人</a-select-option>
                  <a-select-option v-for="(item,index) in teachers" :key="index" :value="item.id">{{item.teacher_name}}</a-select-option>
                </a-select>

                <a-button v-if="tabIndex == 0" style="width:100px;margin-left:10px;flex-shrink: 0;background: #fff;" @click="showRange=true" size="small">{{ range_str }}<a-icon style="font-size: 12px;color: #888;" type="down"></a-icon></a-button>
                <a-button v-if="tabIndex == 0" style="width:100px;margin-left:10px;flex-shrink: 0;background: #fff;" @click="showScene=true" size="small">{{ scene_str }}<a-icon style="font-size: 12px;color: #888;" type="down"></a-icon></a-button>
                <a-button v-if="tabIndex == 0" style="width:100px;margin-left:10px;flex-shrink: 0;background: #fff;" @click="showActivity=true" size="small">{{ act_str }}<a-icon style="font-size: 12px;color: #888;" type="down"></a-icon></a-button>

                <a-space v-if="tabIndex==2">
                  <a-range-picker
                    style="width: 240px;"
                    v-model="searchDate2"
                    @change="changeDateTime2"
                    show-time
                    size="small"
                  >
                    <a-icon slot="suffixIcon" type="carry-out" />
                  </a-range-picker>
                </a-space>

                <a-space v-if="tabIndex == 0" style="margin-left: auto;" :size="4">
                  <a-button
                    @click="reSearch"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    type="primary"
                    >查询</a-button
                  >

                  <a-button
                    @click="handleReset"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    >重置</a-button
                  >

                  <a-button
                    
                    @click="exportState = true"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    >导出</a-button
                  >
                  <a-button
                    v-show="exportState"
                    @click="exportState = false"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    >取消</a-button
                  >
                </a-space>


                <a-space v-else-if="tabIndex == 2" style="margin-left: auto;" :size="4">
                  <a-button
                    @click="reSearchTask"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    type="primary"
                    >查询</a-button
                  >

                  <a-button
                    @click="handleResetTask"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    >重置</a-button
                  >
                </a-space>

                <a-space v-else style="margin-left: auto;" :size="4">
                  <a-button
                    @click="reSearchJtRecord"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    type="primary"
                    >查询</a-button
                  >

                  <!-- <a-button
                    @click="handleResetJtRecord"
                    shape="round"
                    size="small"
                    style="margin-left: auto;"
                    >重置</a-button
                  > -->
                </a-space>
              </div>
            </div>

            
            <div
              style="position: relative"
              infinite-scroll-throttle-delay="200"
              class="list-scroll"
              v-infinite-scroll="getObserveList"
              :infinite-scroll-disabled="busy"
              v-show="tabIndex == 0"
              infinite-scroll-distance="10"
            >
              <observe-list
                @close="closeModal"
                v-model="observeListData"
                :loading="loadMore == 'loading'"
                :isExport="exportState"
                ref="observeList"
              ></observe-list>
            </div>
            <jt-record v-if="tabIndex == 1" ref="jtRecord" :times="jtTime" :student_id="students.length && students[currentStudent].id ? students[currentStudent].id : ''"></jt-record>
              <task-list
              v-if="tabIndex == 2"
                ref="taskListRef"
                :stime="taskListForm.stime"
                :etime="taskListForm.etime"
                :student_id="students.length && students[currentStudent].id ? students[currentStudent].id : ''"
              ></task-list>
          </div>
        </div>
      </div>
    </div>

    <a-drawer
      width="800px"
      placement="right"
      title="学生阶段发展评估报告"
      :visible="showStudentLevelReport"
      @close="showStudentLevelReport = false"
    >
      <div class="report-detail levelStudent">
        <div class="header">
          <div class="msg">
            <div class="avatar-box">
              <img class="avatar" style="width: 80px;" src="../../assets/report-avatar.png" alt="">
              
            </div>
            <div class="title">{{ studentLevelReportDetail.student_name || '' }}</div>
            <div class="time">阶段发展评估报告：{{ studentLevelReportDetail.semester_date || '' }}</div>
          </div>
        </div>

        <div class="repory-content">
          <div class="report_info">
            <div class="info_head">
              <div class="info_title">报告说明</div>

              <div class="panel">
                <div class="panel-cell">
                  <div class="label">评估对象：</div>
                  <div class="info">
                    {{ studentLevelReportDetail.school_name + ' ' + studentLevelReportDetail.class_name + ' '  + studentLevelReportDetail.student_name || '' }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估周期：</div>
                  <div class="info">
                    {{ studentLevelReportDetail.semester_date || '' }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估参考标准：</div>
                  <div class="info">
                    本报告是根据《幼儿园教育指导纲要》和《3-6岁儿童学习与发展指南》为指导
                    ，以"课程评价促进发展"的理念，报告目的在于对课程实施的反馈、调节与改善。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mubiao-list">
            <div v-for="(item,index) in studentLevelReportDetail.records" :key="index" class="mubiao-cell">
              <div class="label">{{ (index + 1) + '.' + item.target3_name }}</div>
              <div class="field">{{item.field_name + '>' + item.target2_name}}</div>
              <div class="info">{{item.target5_name}}</div>
            </div>
          </div>
        </div>
        <div class="student-report-remark">
          <div class="title">评语</div>
          <div class="remark">{{studentLevelReportDetail.remark || '暂无评语'}}</div>
          <a-input-search placeholder="在此输入评论" v-model="pushRemark" @search="handlePushRemark">
            <a-button slot="enterButton">
              发布
            </a-button>
          </a-input-search>
        </div>
      </div>
    </a-drawer>

    <a-modal
        width="720px"
        :visible="showRange"
        @cancel="showRange = false"
        @ok="handleAddRange"
        title="选择领域"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in rangeList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group style="width: 100%;" v-model="rangeCheckedList[index]">
            <a-row>
              <a-col
                v-for="(range, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox @change="() => { range.checked = !range.checked}" :value="range.name">
                  {{ range.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>

    <a-drawer
      :visible="showDraft"
      :title="false"
      placement="right"
      width="600px"
      :closable="false"
      :get-container="false"
      @close="showDraft = false"
      :bodyStyle="{
        padding: '0',
      }"
    >
      <div class="drawer-content">
        <div class="head flex-row">
          <a-icon
            @click="showDraft = false"
            style="color: #999;margin-right: 8px;cursor: pointer;font-size: 14px;"
            type="close"
          />
          <div class="drawer-title">
            草稿箱（{{ draftTotal }}）
          </div>
        </div>

        <div class="draft">
          <draft-list :list="draftList" @load="getDraftList" @del="() =>{draftTotal -= 1}" :loading="loadDraft" :total="draftTotal"></draft-list>
        </div>
      </div>
    </a-drawer>

    <a-modal
        :visible="showScene"
        width="780px"
        @cancel="showScene = false"
        :bodyStyle="{ padding: '10px 20px' }"
        @ok="handleAddCj"
        title="选择场景"
        centered
      >
        <div v-for="(item, index) in sceneList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group style="width: 100%;" v-model="sceneCheckedList[index]">
            <a-row>
              <a-col
                v-for="(child, index2) in item.scenes"
                :key="index2"
                :span="8"
              >
                <a-checkbox @change="() => { child.checked = !child.checked}" :value="child.name">
                  {{ child.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>

      <a-modal
        :visible="showActivity"
        @cancel="showActivity = false"
        @ok="handleAddActivity"
        title="选择活动"
        width="720px"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in activityList" :key="index" class="range">
          <div class="Up">{{ item.name }}</div>
          <a-checkbox-group style="width: 100%;" v-model="activityCheckedList[index]">
            <a-row>
              <a-col v-for="(act, index2) in item.acts" :key="index2" :span="6">
                <a-checkbox @change="() => { act.checked = !act.checked}" :value="act.name">
                  {{ act.name }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>
  </div>
</template>

<script>
import observeList from "../../components/observe-list.vue";
import draftList from "../../components/draft-list.vue";
import taskList from "../../components/task-list.vue";
import jtRecord from '../../components/jt-record.vue';
import moment from "moment";
import axios from "axios";
import { directorTestApi,reportApi } from "../../api/api-director";
import { mapState } from "vuex";
import qs from "qs";


export default {
  data() {
    return {
      range: "全部领域",
      rangeList: [],
      showRange: false,
      cj: "",
      studentLevelReportDetail: {
        student_name: "",
        class_name: "",
        school_name: "",
        title: "",
        items: [],
      },
      pushRemark:'',
      showStudentLevelReport:false,
      exportState: false,
      type: "",
      classList: [],
      className: "班级",
      students: [],
      currentStudent: 0,
      loading: false,
      exchangeClassModal: false,
      busy: false,
      showDraft: false,
      user: "",
      moment,
      tabIndex: "0",
      draftTotal:0,
      loadDraft:false,
      dateRange: [],
      act: "",
      studentListForm: {
        class_id: "",
        currentPage: 1,
        name: "",
        pageSize: 100,
        teacher_id: "",
      },
      taskLists:[],
      observeListForm: {
        act_id: "",
        currentPage: 1,
        etime: "",
        field_id: "",
        name: "",
        pageSize: 5,
        type:"",
        scene_id: "",
        stime: "",
        data_type: "official",
        teacher_id: "",
        student_id:""
      },
      taskListForm: {
        currentPage: 1,
        etime: "",
        field_id: "",
        name: "",
        pageSize: 10,
        type:"",
        scene_id: "",
        stime: "",
        data_type: "official",
        teacher_id: "",
        student_id:""
      },
      form:{
        semester_id:'',
        class_id:'',
        student_id:'',
        school_id:''
      },
      draftFrom: {
        teacher_id: "",
        currentPage: 1,
        pageSize: 15,
        data_type: 'draft'
      },
      observeListData:[],
      loadMore: 'loading',
      sceneList: [], //场景
      rangeList: [], // 领域
      activityList:[], //活动
      activityCheckedList: [],
      sceneCheckedList: [],
      rangeCheckedList: [],
      showScene:false,
      showActivity:false,
      scene_str:'选择场景',
      range_str:"选择领域",
      act_str:'选择活动',
      draftList:[],
      teachers:[],
      searchDate:[],
      jtTime:[],
      jTDefaultTime:[],
      searchDate2:[],
      loadMoreTask: 'more'
    };
  },
  computed: {
    ...mapState(["userInfo", "header","currentClass"]),
  },
  components: {
    observeList,
    draftList,
    taskList,
    jtRecord
  },
  created() {
    this.jTDefaultTime = [moment(new Date()).format('YYYY/MM/DD'), moment(new Date()).format('YYYY/MM/DD')]
    if (this.userInfo) {
      setTimeout(() => {
        this.init()
      }, 1000);
      
      this.getClassList();
      this.getSemesterList()
    }
  },
  watch: {
    
    userInfo(newV) {
      if (newV) {
        setTimeout(() => {
          this.init()
        }, 1000);
        this.getClassList();
        this.getSemesterList()
      }
    },
    showDraft() {
      this.getDraftList()
    },
  },
  beforeRouteEnter(to, from, next) {
    

    next(vm => {
      if (from.path == "/observe/addTask") { 
        setTimeout(() => {
          vm.tabIndex = "2"
        }, 40);
      }
    });
  },
  methods: {
    handlePushRemark() {
      if (!this.pushRemark) {
        this.$message.error({
          content: "请输入评语",
          key: "loading",
        }); 
        return
      }

      //请求接口
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.pushRemark,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          remark: this.pushRemark,
          report_id: this.studentLevelReportDetail.id,
		  student_id: this.form.student_id,
		  teacher_id: this.userInfo.id,
        }),
      }).then((res) => {
		  if (res.data.result) {
			  this.$message.success({
				  content: "提交成功",
				  key: "loading",
			  });
			  this.studentLevelReportDetail.remark = this.pushRemark
			  this.pushRemark = ''
		  } else { 
			  this.$message.error({
				  content: res.data.message,
				  key: "loading",
			  });
		  }
	  })
    },
    getSemesterList() {
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSemesterList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
        }),
      }).then((res) => {
        console.log(res); // 打印ap
        if (res.data.result) {
          this.form.semester_id = res.data.data[0].sm_id; // 设置学期id
        }
      });
    },
    handleStudentLevelReport(student) {
      if (!this.form.student_id) {
        this.$message.error({
          content: "请先选择单一学生",
          key: "loading",
        }); 
        return
      }
      this.$message.loading({
        content: "读取中...",
        key: "loading",
        duration: 0,
      }); // 显示加载中

      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSchoolClassReportStudentDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          semester_id: this.form.semester_id,
          class_id: this.currentClass.id || "",
          school_id: this.userInfo.school_id,
          student_id: this.form.student_id,
        }),
      })
        .then((res) => {
          if (res.data.result && res.data.data) {
            this.studentLevelReportDetail = res.data.data;
            this.studentLevelReportDetail.semester_date = res.data.data.start_time.substr(0, 10) + '~' + res.data.data.end_time.substr(0, 10);
            this.$message.destroy("loading"); // 关闭加载中
            this.showStudentLevelReport = true;

          } else {
            this.$message.destroy("loading"); // 关闭加载中
            this.$message.error(res.data.message); // 显示错误信息
            this.studentLevelReportDetail = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.destroy("loading"); // 关闭加载中
          this.$message.error("读取失败"); // 显示错误信息
        });
    },
    // handleStudentLevelReport(student) {
    //   this.$message.loading({
    //     content: "读取中...",
    //     key: "loading",
    //     duration: 0,
    //   }); // 显示加载中

    //   this.$axios({
    //     method: "post",
    //     url: reportApi.main + reportApi.getSchoolClassReportStudentDetail,
    //     headers: {
    //       "content-type": "application/x-www-form-urlencoded",
    //       Authorization: this.$store.state.headers,
    //     },
    //     data: qs.stringify({
    //       semester_id: this.form.semester_id,
    //       class_id: this.form.class_id,
    //       school_id: this.form.school_id,
    //       student_id: student.student_id,
    //     }),
    //   })
    //     .then((res) => {
    //       if (res.data.result && res.data.data) {
    //         this.studentLevelReportDetail = res.data.data;
    //         this.studentLevelReportDetail.semester_date = res.data.data.start_time.substr(0, 10) + '~' + res.data.data.end_time.substr(0, 10);
    //         this.$message.destroy("loading"); // 关闭加载中
    //         this.showStudentLevelReport = true;

    //       } else {
    //         this.$message.destroy("loading"); // 关闭加载中
    //         this.$message.error(res.data.message); // 显示错误信息
    //         this.studentLevelReportDetail = null;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.$message.destroy("loading"); // 关闭加载中
    //       this.$message.error("读取失败"); // 显示错误信息
    //     });
    // },
    reSearchJtRecord() {
      this.$refs.jtRecord.reSearch()
   },
   changeDateJt(e,time) {
    console.log(this.jtTime)
      // this.jtTime = 
    this.jtTime = [time[0],time[1]]
   },
   handleResetJtRecord() {
      this.$refs.jtRecord.reSet()
   }, 
    handleAddRange() {
      this.range = this.rangeCheckedList.flat();
      this.range_str = this.rangeCheckedList.flat().join('、').substring(0,5) || '全部领域' 
      const field_ids = this.rangeList.map(item=>item.childs).flat().filter(item => item.checked).map(item=>item.id)
      this.observeListForm.field_id = field_ids.join(',')
      this.showRange = false;
    },
    getTeachers() {
      axios({
        method: "POST",
        url: directorTestApi.main + directorTestApi.getCDTeacherList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
          class_id: this.currentClass.id,
          school_id: this.userInfo.school_id
        }) 
      }).then((res) => {
        if (res.data.result) {
          this.teachers = res.data.data
        } else {
          this.teachers = []
        }
      })
    },
    handleAddActivity() {
      this.act_str = this.activityCheckedList.flat().join('、').substring(0,5) || '选择活动'
      const act_ids = this.activityList.map(item=>item.acts).flat().filter(item => item.checked).map(item=>item.id)
      this.observeListForm.act_id = act_ids.join(',')
      this.showActivity = false
    },
    handleAddCj() {
      this.scene_str = this.sceneCheckedList.flat().join('、').substring(0,5) || '选择场景' 
      const scene_ids = this.sceneList.map(item=>item.scenes).flat().filter(item => item.checked).map(item=>item.id)
      this.observeListForm.scene_id = scene_ids.join(',')
      this.showScene = false
    },
    init() {
      this.getRangeList()
      this.getSceneList()
      this.getActList()
    },
    getActList() {
      axios({
        method: "get",
        url: directorTestApi.main + directorTestApi.getObserActList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        params: {
          currentPage: 1,
          pageSize: 100,
          school_id: this.userInfo.school_id
        },
      }).then((res) => {
        this.activityList = res.data.data;
      });
    },
    getSceneList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserSceneList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.sceneList = res.data.data;
      });
    },
    getRangeList() {
      const form = {
        currentPage: 1,
        pageSize: 30,
        school_id: this.userInfo.school_id
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getFieldList,
        headers: { "content-type": "application/x-www-form-urlencoded" ,Authorization: this.$store.state.headers},
        data: qs.stringify(form),
      }).then((res) => {
        this.rangeList = res.data.data;
      });
    },
    getObserveList() {
      console.log(this.currentClass)
      if (!this.currentClass || !this.currentClass.id) return
      if (this.loadMore == 'nomore' || this.busy || !this.userInfo) return
      this.busy = true
      this.loadMore = 'loading'
      this.observeListForm.school_id = this.userInfo.school_id || ""
      this.observeListForm.class_id = this.currentClass.id || ""
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRecordList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers},
        data: qs.stringify({
          ...this.observeListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.busy = false
        if (res.data.result) {
          this.loadMore = 'loadmore'
          this.loading = false
          this.observeListForm.currentPage++
          this.observeListData = [...this.observeListData , ...res.data.data]
          if (res.data.data.length < this.observeListForm.pageSize) {
            this.loadMore = 'nomore'
          }
        } else {
          this.loadMore = 'nomore'
          this.loading = false
          // this.$message.error(res.data.message);
        }
      }).catch((e) => {
        this.loading = false
        this.busy = false
        this.$message.error('网络服务错误')
      })
    },
    getTaskList() {
      if (this.loadMoreTask != 'loadmore' || !this.userInfo) return
      this.loadTaskTime = new Date().getTime()
      this.loadMoreTask = 'loading'
      this.taskListForm.school_id = this.userInfo.school_id || ""
      this.taskListForm.teacher_id = this.userInfo.id
      const time = this.loadTaskTime
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserTaskList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...this.taskListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.loadMoreTask = 'loadmore'
          this.loading = false
          this.taskListForm.currentPage++
          this.taskLists = [...this.taskLists , ...res.data.data]
          if (res.data.data.length < this.taskListForm.pageSize) {
            this.loadMoreTask = 'nomore'
          }
        } else {
          this.loadMoreTask = 'nomore'
          this.loading = false
          // this.$message.error(res.data.message);
        }
      }).catch((e) => {
        console.log(e);
        this.loadMoreTask = 'loadmore'
        this.loading = false
        this.busy = false
        this.$message.error('网络服务错误')
      })
    },
    getDraftList() {
      if (this.draftMore == 'nomore' || !this.userInfo || this.loadDraft) return
      this.draftFrom.teacher_id = this.userInfo.id
      this.draftFrom.school_id = this.userInfo.school_id || ""
      this.loadDraft = true
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRecordList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...this.draftFrom,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.loadDraft = false
          this.draftTotal = res.data.extral
          this.draftFrom.currentPage++
          this.draftList = [...this.draftList , ...res.data.data]
          if (res.data.data.length < this.draftFrom.pageSize) {
            this.draftMore = 'nomore'
          }
        } else {
          this.loadDraft = false
          this.draftTotal = 0
        }
      }).catch((e) => {
        this.$message.error('网络服务错误')
      })
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        teacher_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.userInfo.school_id || ""
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        if (res.data.result) {
          this.classList = res.data.data;
          this.className = this.classList[0].class_name;
          this.draftFrom.class_id = this.classList[0].id;
          this.observeListForm.class_id = this.classList[0].id;
          this.$store.state.currentClass = this.classList[0];
          this.getObserveList()
          this.getTeachers()
          this.getAllStudents();
        } else {
          this.$message.error('未获取到您的班级');
          this.loadMore = 'nomore'
        }
      });
    },
    getAllStudents() {
      this.studentListForm = {
        class_id: this.currentClass.id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        teacher_id: this.userInfo.id,
        school_id: this.userInfo.school_id || "",
      };

      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.studentList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.students = [
          { name: "全部学生", id: "", class_id: "" },
          ...res.data.data,
        ];
      });
    },
    changeDateTime(e, time) {
      this.observeListForm.stime = time[0];
      this.observeListForm.etime = time[1];
    },
    changeDateTime2(e, time) {
      this.taskListForm.stime = time[0];
      this.taskListForm.etime = time[1];
    },
    changeRange(e, s) {
      this.showRange = true;
    },
    changeConfirmRange() {
      this.range = this.rangeCheckedList.join("、");
      //截取5个字，如果超出用...代替
      if (this.range.length > 5) {
        this.range = this.range.substring(0, 5) + "...";
      }

      if (this.range.length == 0) {
        this.range = "全部领域";
      }

      const range_ids = this.rangeList.map(item=>item.childs).flat().filter((item) => item.checked).map(item=>item.id);
      this.observeListForm.field_id = range_ids.join(',')

      this.showRange = false;
    },
    handleReset() {
      this.dateRange = [];
      this.user = "";
      this.range_str = "全部领域";
      this.scene_str = "全部场景"
      this.act_str = "全部活动";
      this.observeListForm.field_id = ""
      this.observeListForm.scene_id = ""
      this.observeListForm.act_id = ""
      this.observeListForm.stame = "";
      this.observeListForm.etime = "";
      this.observeListForm.type = ""
      this.observeListForm.teacher_id = ""
      this.searchDate= []
      this.cj = "";
      this.act = "";
      this.type = "";
      this.reSearch()
      setTimeout(() => {
        this.loading = false;
      }, 400);
    },
    closeModal() {
      // this.loading = true;
      // this.busy = false;
      // setTimeout(() => {
      //     this.loading = false;
      // }, 20);
    },
    // loadMore() {
    //   this.busy = true;
    //   if (this.$refs.observeList) {
    //     this.$refs.observeList.loadMore();
    //   }

    //   setTimeout(() => {
    //     this.busy = false;
    //   }, 30);
    // },
    handleMenuClick(e) {
      this.className = e.class_name;
      this.getAllStudents();
      this.$store.state.currentClass = e;
    },
    changeTab(e) {
      this.tabIndex = e;
    },
    handleOk() {
      this.exchangeClassModal = false;
    },
    reSearch() {
      this.loading = true;
      this.busy = false;
      this.loadMore = 'loading'
        this.observeListForm.currentPage = 1
        this.observeListData = []
        this.getObserveList()
      
    },
    handleResetTask() {
      this.searchDate2 = []
      this.$refs.taskListRef.reSet()
    },
    reSearchTask() {
      this.$refs.taskListRef.reSearch()
    },
    changeStudent(index) {
      this.currentStudent = index;
      this.observeListForm.student_id = this.students[this.currentStudent].id
      this.taskListForm.student_id = this.students[this.currentStudent].id
      this.form.student_id = this.students[this.currentStudent].id
      this.draftFrom.currentPage = 1
      this.draftMore = false

      this.reSearch()
      this.getDraftList()
    },
  },
};
</script>
<style lang="scss">
.student-report-remark {
  .title {
    font-weight: bold;
    font-size: 16px;
    padding:10px 0;
  }
  
  .remark {
	  padding: 10px;
	  background: #f3f3f3;
	  border-radius: 6px;
	  margin-bottom: 10px;
  }
  
}
.report_info {
  border-radius: 12px;
  overflow: hidden;
  .info_head {
    width: 100%;
    background: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;

    .info_title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      padding: 10px 20px;
      text-align: center;
    }

    .info_list {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .number {
          font-size: 24px;
          font-weight: bold;
          color: #67b0db;
        }

        .label {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}
.report-detail {
  width: 100%;
  background: #fff;

  .header {
    width: 100%;
    padding-top: 20px;
    z-index: 10;
    box-sizing: border-box;
    position: relative;

    .back {
      width: 80%;
      display: block;
      overflow: hidden;
      margin: 0 auto;
    }

    .msg {
      width: 100%;
      text-align: center;
      font-size: 20px;
      position: absolute;
      top: 40px;

      .school {
        font-size: 14px;
        color: #8a8a8a;
        font-weight: bold;
      }

      .title {
        font-size: 20px;
        color: #65afdc;
        font-weight: bold;
        margin: 6px 0;
      }

      .class_name {
        font-size: 12px;
        color: #555;
      }
    }
  }

  &.levelStudent {
    
    .msg {
      position: static;
      margin-bottom: 20px;

      .time {
        font-size: 14px;
        color: #8a8a8a;
      }
    }

    .repory-content {
      background: #c3e7f9;
      border-radius: 6px;
      padding: 10px;
      .mubiao-list {
        width: 100%;
        border-radius: 6px;
        overflow: hidden;
        margin-top: 10px;
        box-sizing: border-box;
        .mubiao-cell {
          width: 100%;
          padding: 15px 20px;
          border-bottom: 1px solid #f3f3f3;
          background: #fff;
          margin-bottom: 10px;
          border-radius: 5px;
          &:last-child {
            border-bottom: none;
          }
          .label {
            font-size: 16px;
            color: #65afdc;
            font-weight: bold;
          }
          .field {
            font-size: 14px;
            color: #666;
          }
          .info {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            line-height: 20px;
          }
        }
      }
    }

    .info_foot {
    width: 100%;
    height: 100px;
    background: #fff;
    margin-top: 5px;
    padding: 10px 20px;
    border-radius: 5px;

    .top_name {
      font-size: 14px;
      font-weight: bold;
      color: #666;
      margin-bottom: 4px;
    }

    .tips {
      font-size: 14px;
      color: #666;
    }
  }
  }

  .content {
    width: 100%;
    background: #c4e7fa;
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 15px;
  }
}

.report-detail.student {
  position: relative;
  background-image: url("../../assets/report_stu.jpg");
  background-size: 40% auto;
  background-position: center top;
  background-repeat: no-repeat;

  .header {
    overflow: hidden;
    padding-top: 0;
  }

  .msg {
    top: 30px;
    margin-top: 130px;
    position: static;

    .avatar {
      width: 60px;
      height: 60px;
      border: 7px solid #4c8b9c;
      border-radius: 100%;
      background: #fff;
      z-index: 1;
    }

    .title {
      color: #67aeda;
    }

    .name {
      width: 100px;
      // background: #fcd388;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      padding: 3px 10px;
      border-radius: 100px;
      margin: 0px auto 0;
      z-index: 10;
    }
  }

  .record {
    padding: 10px 20px;
    z-index: 100;
    padding-top: 30px;
    background: #c4e7fa;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

    .title {
      font-size: 16px;
      color: #585858;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
  }

  .history {
    padding: 10px 20px;
    z-index: 100;
    margin-top: 50px;
    background: #c4e7fa;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .title {
      font-size: 16px;
      color: #585858;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }

    .list {
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      display: flex;
      box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.1);
      flex-direction: column;
      align-items: center;

      .item {
        margin: 2px 0;
      }
    }
  }
}
.panel {
  width: 100%;
  .panel-cell {
    width: 100%;
    padding: 2px 20px;
    .label {
      font-size: 14px;
      color: #444;
      display: inline;
      font-weight: bold;
    }
    .info {
      font-size: 14px;
      color: #666;
      display: inline;
    }
  }
}
.report-detail .content-sys {
  padding: 20px;
  .msg {
    text-align: left;
    .school {
      font-size: 16px;
    }
    .class_name {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.student-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 16.6666%;
    padding: 20px 0;
    background: #f5f5f5;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 55px;
      height: 55px;
      margin-bottom: 10px;
      border-radius: 10px;
    }

    .name {
      font-size: 14px;
      color: #333;
    }
  }
}
</style>
<style lang="scss">
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .drawer-title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .teacher {
    padding: 15px;
    border-bottom: 1px solid #ececec;
    .left {
      flex-direction: column;
      align-items: flex-start;
      font-size: 12px;
      color: #6a6a6a;
      margin-left: 10px;
      .name {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .flex-row {
      justify-content: space-between;
      width: 100%;
    }
  }

  .content {
    padding: 15px;
  }
}
</style>

<style lang="scss" scoped>
.list-wrap {
  margin-top: -6px;
  .search {
    padding: 0 15px;
    background: #fff;
    .flex-row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      height: 50px;
      padding-top: 6px;
      justify-content: flex-start;
    }
  }
}
.list-scroll {
  height: calc(100% - 15px);
  overflow-y: scroll;
  padding-top: 10px;
}

.scroll-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .content-box {
    flex-shrink: 0;
    height: calc(100% - 66px);
  }
}
.head-title {
  .name {
    flex-shrink: 0;
  }
}

.content-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 15px 0;

  .left {
    width: 270px;
    background: #fff;
    margin-right: 15px;
    border-radius: 5px;
    padding: 10px 0;
    height: 100%;
    flex-shrink: 0;

    .students {
      width: 100%;
      height: calc(100% - 59px);
      overflow-y: auto;
      padding: 10px;

      .student-item {
        padding: 6px 10px;
        cursor: pointer;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px dashed #dedede;

        .name {
          margin-right: 10px;
          width: 60px;
          color: #888;
          font-size: 14px;
        }
        .msg {
          color: #46a6f5;
          font-size: 12px;
          white-space: nowrap;
          transform: scale(0.9) translate(9%, 10%);

          span {
            font-size: 13px;
            color: #666;
            margin-left: 6px;
          }
        }
        &.active {
          background: #67b0dc;
          color: #fff;
          border-bottom: none;

          .name {
            color: #fff;
          }

          .msg {
            color: #fff;

            span {
              color: #fff;
            }
          }
        }
      }
    }
  }

  .right {
    width: calc(100% - 300px);
    background: #fff;
    height: 100%;
    border-radius: 5px;
    overflow: hidden;

    .tabs {
      padding: 0px 25px;
      margin-top: 10px;
    }

    .head {
      position: relative;

      .title {
        border-radius: 15px 15px 0 0;
        background: #67b0dc;
        padding: 0px 10px;
        height: 50px;
        line-height: 50px;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
      }

      .pos {
        position: absolute;
        right: 20px;
        top: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .cg {
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #898989;
          border-radius: 0 0 5px 5px;
          margin-right: 20px;
          color: #fff;
          cursor: pointer;
        }

        .push {
          width: 100px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #f39801;
          border-radius: 0 0 5px 5px;
          color: #fff;
          cursor: pointer;
        }
      }
    }

    .list-wrap {
      height: calc(100% - 150px);
      padding: 0 10px;
    }
  }
}

.scroll-wrapper {
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 20px;
  right: 0;
}

.class {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 20px;
  .name {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
    padding: 10px 0;
    color: #67b0dc;
    margin-left: -4px;
  }

  .a-button {
    font-size: 12px;
  }
}

.tip {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
  margin-left: 20px;
}
.class-list {
  width: 100%;
  .class-list-cell {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
  }
}

.drop {
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 5px;
  padding: 10px;
}
input[aria-hidden="true"] {
        display: none !important;
    }
@import url(../../assets/drawer.scss);
</style>
